import React from 'react'

import { Button, DDSIconDefinition, FeatureBadge, Icon, styled } from '@driftt/dds'
export interface MenuButtonProps {
  icon: DDSIconDefinition
  title: string
  isNew?: boolean
  isActive?: boolean
  onClick?: () => void
}

const StyledButton = styled(Button, {
  padding: '4px 8px',
  fontWeight: '400!important',
  width: '168px',
  justifyContent: 'left',
  border: 'none',
  '&.active': {
    backgroundColor: '$blue1!important',
    color: '$blue8',
  }
})

const PreferencesMenuButton = ({ icon, title, isNew=false, isActive=false, onClick }: MenuButtonProps) => {
  return (
    <StyledButton variant="tertiary" className={isActive ? 'active' : ''} onClick={onClick}>
      <Icon icon={icon} />
      {title}
      {isNew && <FeatureBadge variant="new" />}
    </StyledButton>
  )
}

export default PreferencesMenuButton
